module.exports = __webpack_public_path__ + "img/7.bd800a5b.jpg";